import { useDraggable } from "@dnd-kit/core";
import styles from "./Draggable.module.css";
import React, {
  type CSSProperties,
  type RefObject,
  useRef,
  useState,
} from "react";
import { useEditMarket } from "../../provider/edit-market/EditMarket.hook.ts";
import { useDragAndDrop } from "../../provider/drag-and-drop/DragAndDrop.hook.ts";
import type DraggableProperties from "./Draggable.properties.ts";

export default function DraggableView(props: DraggableProperties) {
  const x = props.marketComponentDetails?.position?.x ?? 0;
  const y = props.marketComponentDetails?.position?.y ?? 0;
  const localRef = useRef<HTMLDivElement>(null);
  const [top, setTop] = useState(0);
  const { enableZoom } = useEditMarket();
  const { transformState } = useDragAndDrop();

  let details = null;

  if (typeof props.marketComponentDetails !== "undefined") {
    details = props.marketComponentDetails;
  }

  if (typeof props.marketComponentTypeDetails !== "undefined") {
    details = props.marketComponentTypeDetails;
  }

  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: props.id,
      disabled: props.disabled,
      data: {
        details: details,
      },
    });

  const handlePointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
    if (event.button !== 0) return;

    if (!enableZoom) {
      if (props.position === "relative") {
        const rect = localRef.current?.getBoundingClientRect();
        setTop(rect?.top ?? 0);
      }
    }

    if (listeners?.onPointerDown) {
      listeners.onPointerDown(event);
    }
  };

  const handlePointerUp = (event: React.PointerEvent<HTMLDivElement>) => {
    if (event.button !== 0) return;

    if (!enableZoom) {
      setTop(0);
    }

    if (listeners?.onPointerUp) {
      listeners.onPointerUp(event);
    }
  };

  return (
    <div
      ref={(node) => {
        setNodeRef(node);
        (localRef as RefObject<HTMLDivElement | null>).current = node;
      }}
      className={styles.container}
      style={
        {
          "--transform":
            isDragging && props.position !== "relative"
              ? `translate3d(${(transform?.x || 0) / (transformState?.scale ?? 1) + x}px, ${(transform?.y || 0) / (transformState?.scale ?? 1) + y}px, 0)`
              : `translate3d(${(transform?.x || 0) + x}px, ${(transform?.y || 0) + y}px, 0)`,
          "--position":
            props.position && !isDragging ? props.position : "fixed",
          "--top": top,
        } as CSSProperties
      }
      {...listeners}
      onPointerDown={handlePointerDown}
      onPointerUp={handlePointerUp}
      {...attributes}
    >
      {props.children}
    </div>
  );
}
